import { connect } from 'react-redux';
import { Redirect, Route, RouteComponentProps, RouteProps } from 'react-router-dom';
import type { StaticContext } from 'react-router';
import { useUnmount } from 'react-use';
import type { Dispatch } from 'redux';

import { getUserInfo, getUserRole } from 'AuthPackage/MainModule/selectors/authSelectors';
import { IUserInfo } from 'APIPackage/AuthModule/interfaces/IUserInfo';
import { IUserRole } from 'APIPackage/AuthModule/interfaces/IUserRole';
import { removeAllNoticesAction } from 'CorePackage/NotificationModule/actions/NoticeActions';
import { getAccountOrganizationsData } from 'CorePackage/AccountModule/selectors/accountSelectors';
import { IUserOrganisation } from 'APIPackage/AccountModule/interfaces/IUserOrganisation';

import { ROUTE_AUTH, ROUTE_LK } from '../routes/routes';
import { IRootState } from '../interfaces/IRootState';
import { RootActions } from '../types/RootActions';

interface IPrivateRouteProps {
  user?: IUserInfo;
  role?: IUserRole;
  checkOrganizations: boolean;
  knoOrganisations: IUserOrganisation[];
  prosecutorOrganisations: IUserOrganisation[];
  removeAllNotices: () => void;
}

const PrivateRouteWithoutStore = ({
  user,
  role,
  component,
  checkOrganizations,
  knoOrganisations,
  prosecutorOrganisations,
  removeAllNotices,
  ...routeProps
}: RouteProps & IPrivateRouteProps) => {
  const Component = component !== undefined ? component : () => null;

  useUnmount(() => {
    removeAllNotices();
  });

  function renderComponent(
    props: RouteComponentProps<
      {
        [x: string]: string | undefined;
      },
      StaticContext,
      unknown
    >,
  ) {
    return (
      <>
        {user !== undefined &&
          ((checkOrganizations &&
            ((prosecutorOrganisations.length > 0 && knoOrganisations.length > 0 && <Component {...props} />) || (
              <Redirect to={ROUTE_LK} />
            ))) ||
            (!checkOrganizations && <Component {...props} />))}
        {user === undefined && <Redirect to={ROUTE_AUTH} />}
      </>
    );
  }

  return <Route {...routeProps} render={renderComponent} />;
};

const mapStateToProps = (state: IRootState) => ({
  user: getUserInfo(state),
  role: getUserRole(state),
  knoOrganisations: getAccountOrganizationsData(state).kno,
  prosecutorOrganisations: getAccountOrganizationsData(state).prosecutor,
});

const mapDispatchToProps = (dispatch: Dispatch<RootActions>) => ({
  removeAllNotices: () => dispatch(removeAllNoticesAction()),
});

export const PrivateRoute = connect(mapStateToProps, mapDispatchToProps)(PrivateRouteWithoutStore);
